module.exports = __webpack_public_path__ + "img/desktop-elbow-1_56x112.ab98056e.png";